import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class UserService {

  detailReload$ = new Subject<any>();

  detailReload() {
    this.detailReload$.next(true);
  }

}
